import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c2062a70"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "",
    src: "/assets/img/logo-small.svg"
  })
], -1))
const _hoisted_2 = { class: "rank" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("級"),
  /*#__PURE__*/_createElementVNode("rp", null, "（"),
  /*#__PURE__*/_createElementVNode("rt", null, "きゅう"),
  /*#__PURE__*/_createElementVNode("rp", null, "）")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("ruby", null, [
    /*#__PURE__*/_createTextVNode("試験"),
    /*#__PURE__*/_createElementVNode("rp", null, "（"),
    /*#__PURE__*/_createElementVNode("rt", null, "しけん"),
    /*#__PURE__*/_createElementVNode("rp", null, "）")
  ]),
  /*#__PURE__*/_createTextVNode("スタート")
], -1))
const _hoisted_5 = [
  _hoisted_4
]

import {ref, inject} from "vue"
import { useRoute, useRouter } from 'vue-router'
import { examKey } from "@/main";
import { QuestionData } from "@/store/exam";
import DemoControl from "@/components/parts/DemoControl.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ExamStart',
  emits: ['overridePageName'],
  setup(__props) {

const route = useRoute();
const router = useRouter();

const exam = inject(examKey);


const group = route.params.group;

const questions = ref<QuestionData>();
const rank = ref<string | null>(null);
const rankName = ref<string | null>(null);

const init = async () => {
  questions.value = await exam?.questions();
  if (!questions.value) return;
  rank.value = questions.value.rank;
  rankName.value = questions.value.name;
}
init();

const next = async () => {
  exam?.startFullScreen();
  router.replace(`/cbt/${group}/caution`);
}

const demoPrev = () => router.replace(`/cbt/${group}/volume`);
const demoNext = () => router.replace(`/cbt/${group}/caution`);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, [
        _createElementVNode("span", null, [
          _createTextVNode(_toDisplayString(rank.value), 1),
          _hoisted_3
        ]),
        _createElementVNode("span", null, _toDisplayString(rankName.value), 1)
      ])
    ]),
    _createElementVNode("a", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (next())),
      class: "m-btn is-center"
    }, _hoisted_5),
    _createVNode(DemoControl, {
      onPrev: demoPrev,
      onNext: demoNext
    })
  ], 64))
}
}

})